import { isEmail } from './email';
import { isPhone } from './phone';
import { isRequired } from './required';

export const validators = {
  isEmail,
  isPhone,
  isRequired,
};
